import React from "react";

import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";

import EventsChartForm from "./events-chart-form";
import EventsChartsData from "./events-charts-data";
import ET3PageDiv from "../../../core/et3-page-div";

const EventsChart = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_EVENTS_CHARTS",
      "AUDITOR_EVENTS_CHARTS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN")}
        subTitle={i18n.get("VIEW_ADMIN_EVENTS_CHARTS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <EventsChartForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <EventsChartsData />
    </ET3PageDiv>
  );
});
export default EventsChart;
